// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SearchResults":"jg_a bhl_a bhl_j bhl_q bhl_st bhl_su bhl_w"};